import axios from 'axios';

import {
  axiosHeader,
  axiosHeaderV2,
  getV1RootUrl,
  getV2RootUrl
} from 'common/helpers/apiHelper';

export const editClubShipmentItems = (
  customerId,
  clubMemberShipmentId,
  items
) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/items`,
    { items },
    axiosHeaderV2()
  );

export const getClubShipmentVirtualCart = (customerId, clubMemberShipmentId) =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/virtual-cart`,
    axiosHeaderV2()
  );

export const getClubShipmentVirtualCartLimited = (clubMemberShipmentId) =>
  axios.get(
    `${getV2RootUrl()}/club-member-shipment/${clubMemberShipmentId}/virtual-cart/limited`,
    axiosHeaderV2()
  );

export const editClubVirtualShipmentItems = (
  customerId,
  clubMemberShipmentId,
  items
) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/virtual-cart`,
    { items },
    axiosHeaderV2()
  );

export const shipShipmentNow = (customerId, clubMemberShipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/ship-now`,
    null,
    axiosHeader()
  );

export const skipClubShipment = (customerId, clubMemberShipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/skip`,
    null,
    axiosHeader()
  );

export const unskipClubShipment = (customerId, clubMemberShipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-member-shipment/${clubMemberShipmentId}/unskip`,
    null,
    axiosHeader()
  );
